import React, { ReactNode } from "react";

interface Props {
  body: ReactNode;
  warning?: boolean;
}

export default function PillTag({ body, warning }: Props) {
  return (
    <span className={`px-2 text-xs whitespace-nowrap font-semibold leading-6 text-gray-500 ${warning ? "bg-yellow-100" : "bg-gray-100"} rounded-full`}>
      {body}
    </span>
  );
}
